import login1 from '../../../../shared/img/ppt/login1.png';
import login2 from '../../../../shared/img/ppt/login2.png';

const addSlide4 = (pptx, addBrandingToSlide, sortedCodes) => {
  // presentation slide
  const slide4 = pptx.addSlide({ masterName: 'COMPANY_BRANDING' });
  slide4.addText('PROCEDURE D\'INSCRIPTION', {
    x: 1.25,
    y: 0.25,
    w: 8,
    h: 0.5,
    align: 'center',

    // Style du texte
    fontSize: 22,
    color: '4f4f4f',
    bold: true,

    // Style de la forme
    shape: pptx.ShapeType.rect,
    fill: { color: 'fae3f2' },

    // Bordure
    line: {
      color: 'f71616', // rouge foncé
      width: 1, // épaisseur de la bordure
    },
  });

  slide4.addText([
    { text: 'Rendez-vous sur le site: ' },
    { text: 'https://englishworld-learning.fr', options: { bold: true } },
  ], {
    x: 1.25,
    y: 0.75,
    w: 7,
    h: 0.5,
    align: 'center',
    fontSize: 16,
    color: '696969',
  });

  slide4.addImage({
    path: login1,
    x: 0.5,
    y: 1.3,
    w: 4,
    h: 2,
  });

  slide4.addText([
    { text: '1. Cliquez sur «Créer un compte»\n', options: { color: '696969' } },
    { text: '2. Saisir le code d\'accès suivant : ', options: { color: '696969' } },
    { text: `"${sortedCodes[0].name || ''}"\n`, options: { bold: true, color: '696969' } },
    { text: '3. Cliquez sur : «Suivant»', options: { color: '696969' } },
  ], {
    x: 5,
    y: 1.5,
    w: 4.8,
    h: 1,
    fontSize: 15,
    shape: pptx.ShapeType.rect,
    fill: { color: 'ffffff' },
    wrap: true,
    line: {
      color: 'FF0000',
      width: 1,
    },
  });
  slide4.addImage({
    path: login2,
    x: 0.5,
    y: 3.5,
    w: 4,
    h: 2,
  });

  slide4.addText(
    [
      { text: '4. Renseignez les éléments suivants :\n', options: { color: '696969' } },
      { text: '•  Votre nom et prénom\n', options: { color: '696969' } },
      { text: '•  Votre adresse email (scolaire)\n', options: { color: '696969' } },
      { text: '•  Votre semestre en cours\n', options: { color: '696969' } },
      { text: '•  Choisir un mot de passe\n', options: { color: '696969' } },
      { text: '\n5. Cliquez sur « Créer un compte »', options: { color: '696969' } },
    ],
    {
      x: 5,
      y: 3,
      w: 4.8,
      h: 2.5,
      fontSize: 15,
      align: 'top',
      shape: pptx.ShapeType.rect,
      fill: { color: 'ffffff' },
      line: { color: 'FF0000', width: 1 },
      bullet: false, // On gère les puces manuellement avec "•"
    },
  );

  addBrandingToSlide(pptx, slide4);
};

export default addSlide4;
